import { useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type academiesTags_Query } from "@relay/academiesTags_Query.graphql";
import { QUERY } from "./academies-tags.graphql";
import { AcademiesTagsTable } from "./parts/academies-tags-table";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const AcademiesTagsScreen = () => {
	const query = useLazyLoadQuery<academiesTags_Query>(QUERY, {});
	const { t } = useTranslation("common");
	const canReadAndModify = useHasPermissions([
		"UserInAccountPermission_TagAdmin_Read",
		"UserInAccountPermission_TagAdmin_Modify",
	]);

	if (!canReadAndModify) {
		return <NoAccess />;
	}

	return (
		<BaseScreen title={t("general.keywords")}>
			<AcademiesTagsTable queryFragmentRef={query} />
		</BaseScreen>
	);
};
